var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-5",
    cx: 250,
    cy: 355.23,
    rx: 223.4,
    ry: 121.49,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-5",
    cx: 250,
    cy: 329.43,
    rx: 33.66,
    ry: 19.44,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 375.53,
    cy: 370.1,
    rx: 53.21,
    ry: 30.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-5",
    cx: 114.42,
    cy: 373.42,
    rx: 53.21,
    ry: 30.72,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455,348.27l-10.05-4.11a214.38,214.38,0,0,1-2.18-26.22c0-16.42,10.23-36.5,23.21-33.14s-3.66,21.73-6.36,35.92S455,348.27,455,348.27Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,348.27l-10.05-4.11a214.38,214.38,0,0,1-2.18-26.22c0-16.42,10.23-36.5,23.21-33.14s-3.66,21.73-6.36,35.92S455,348.27,455,348.27Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.13,347h0a.42.42,0,0,0,.36-.47c-4.79-36,11.4-56,11.56-56.17a.42.42,0,1,0-.65-.54c-.16.2-16.59,20.44-11.75,56.82A.42.42,0,0,0,450.13,347Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.16,350.67l-5.25-2.38a55.79,55.79,0,0,1,.7-24.41c3.37-12.94,14.59-20.92,20.24-19.6,6.91,1.61,7.58,8,5.56,12.45C479,322,462.38,336.27,460.16,350.67Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.16,350.67l-5.25-2.38a55.79,55.79,0,0,1,.7-24.41c3.37-12.94,14.59-20.92,20.24-19.6,6.91,1.61,7.58,8,5.56,12.45C479,322,462.38,336.27,460.16,350.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.43,349.84h0a.43.43,0,0,0,.38-.47c-2.36-22.84,17.57-40.4,17.78-40.57a.44.44,0,0,0,0-.6.42.42,0,0,0-.6,0c-.21.18-20.46,18-18.07,41.3A.44.44,0,0,0,457.43,349.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,339.07l6.9-3.94s3.3-18.21.83-33.87c-3.48-22-18.47-29.61-23.91-27.42s-6.72,8.71,3.11,21.43C48.73,302.77,56.19,318.64,56,339.07Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56,339.07l6.9-3.94s3.3-18.21.83-33.87c-3.48-22-18.47-29.61-23.91-27.42s-6.72,8.71,3.11,21.43C48.73,302.77,56.19,318.64,56,339.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,330.33h-.07a.48.48,0,0,1-.41-.55c2.84-20.61-5.44-43.19-14.76-52.29a.5.5,0,1,1,.69-.71C53.43,286,61.88,309,59,329.9A.5.5,0,0,1,58.5,330.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.88,350.12c-1.09.62-3.33-.74-4.19-1.32a10.52,10.52,0,0,1-3.46-4,9.73,9.73,0,0,1-.86-5.85,22.65,22.65,0,0,1,.74-3.11l.87-3a7.75,7.75,0,0,0,.44-3c-.26-2.07-2.1-3.51-3.76-4.76-1.85-1.38-3.76-3.2-3.75-5.69a8.66,8.66,0,0,1,2.19-5.2c1.18-1.51,2.59-2.84,3.67-4.43A6.07,6.07,0,0,0,30,305.87a6.37,6.37,0,0,0-.84-2.41,33.46,33.46,0,0,1-2.64-4.84c-.61-1.74-.52-3.9.84-5.15a5.67,5.67,0,0,1,4.27-1.06,9.74,9.74,0,0,1,4,1.4c3.95,2.19,6.2,6.87,10.39,8.56a41,41,0,0,0,5.06,1.23,6.24,6.24,0,0,1,4.18,2.87c1.54,3.07-1.31,6.85-.23,10.11,1,2.88,3.76,4,5.33,6.59a6.14,6.14,0,0,1,.74,3.77,18.26,18.26,0,0,1-1.59,6.38A45.34,45.34,0,0,1,56,339.07C55.94,339.14,37.05,350,36.88,350.12Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.07,344.16h0a.5.5,0,0,1-.48-.52c.81-19.5-8.38-41-15.06-47.3a.49.49,0,0,1,0-.69.5.5,0,0,1,.7,0C40,302,49.39,323.9,48.56,343.69A.49.49,0,0,1,48.07,344.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.15,321.11l-.15,0a66.53,66.53,0,0,0-14.15-2.29.49.49,0,1,1,0-1,67.36,67.36,0,0,1,14.4,2.33.49.49,0,0,1,.33.61A.5.5,0,0,1,45.15,321.11Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.83 363.76 392.51 362.69 390.1 343.91 401.49 347.29 401.83 363.76",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,379.08a2.81,2.81,0,0,0,.16,2.28c1,1.16,3.58,2.52,7.1,2.77,3.37.24,6.37-.21,8.34-1.46a5.83,5.83,0,0,0,3.12-4.56c.19-1.91,0-3.76.89-5.23s2.18-2.9,2.47-3.64a7.45,7.45,0,0,0,0-3.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.62,362.36a7.77,7.77,0,0,1-.39,2.13,19.56,19.56,0,0,1-2.06,4.21,17.23,17.23,0,0,1-1.4,2c-1,1.21-2.28,2.21-3.36,3.37a6.9,6.9,0,0,0-2.08,4.12c-.14,2.64,4.06,3.54,6.27,3.93a16.19,16.19,0,0,0,7.16-.36,6.57,6.57,0,0,0,4.82-5.25c.13-.74.08-1.49.17-2.22a10.35,10.35,0,0,1,2.05-4.62,13.69,13.69,0,0,0,1.57-2.51c.69-1.63.14-3.47-.3-5.09-.38-1.41-.84-3-1.34-2.89,0,.73,0,.83-.49,1.32s-.68,1.57-1.38,2.12a10.11,10.11,0,0,0,.49-1.88,1.05,1.05,0,0,0-.15-.74,2,2,0,0,0-.81-.44,16.68,16.68,0,0,0-3.2-.73,19.66,19.66,0,0,0-4.47,0,1.33,1.33,0,0,0-.79.46,1.63,1.63,0,0,0-.28.9C390.6,360.57,390.64,361.66,390.62,362.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.81,369.26c1-.74,4.53-.75,5.73-.62a7.26,7.26,0,0,1,3.42,1.2.78.78,0,0,0,1-.08h0a.74.74,0,0,0-.08-1.12,7.43,7.43,0,0,0-3.84-1.43,19.86,19.86,0,0,0-5.18.3S387.52,368.38,387.81,369.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.55,372c1.24-.73,5-.63,6.21-.5a6.83,6.83,0,0,1,3.32,1.27.79.79,0,0,0,1-.08h0a.74.74,0,0,0-.08-1.12,14.26,14.26,0,0,0-5.27-1.54c-3-.21-3.73.39-3.73.39A2.49,2.49,0,0,0,385.55,372Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.22,364.38a14.56,14.56,0,0,0-5.06.31c-.52.29-.87,1.12-.53,1.33a14.22,14.22,0,0,1,4.64-.46,9.9,9.9,0,0,1,3.2.88c.26.12.56.27.82.42a.69.69,0,0,0,1-.3h0a.66.66,0,0,0-.25-.85A9.55,9.55,0,0,0,395.22,364.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.08 355.22 358.22 352.75 358.22 334.84 369.21 335.32 367.08 355.22",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.5,364.81a3.27,3.27,0,0,0,.13,2.35c.33.68,3.92,2.71,8.76,2.38a20.22,20.22,0,0,0,10-3.5c1.84-1.22,3.76-1.45,6.16-1.58s5.54-1.34,6.07-2.46a5.35,5.35,0,0,0-.08-3.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,349.71l-.38-.08a1.39,1.39,0,0,0-.64,0,1.35,1.35,0,0,0-.6.4,11.88,11.88,0,0,0-1.23,1.95c-1,1.65-3.15,3-5.47,4.27-1.58.85-3.13,1.51-4.76,2.24s-3.88,1.21-5.18,2.09c-1.9,1.28-2.15,4.49,0,5.76,1.86,1.1,6.78,2.29,11.93.83,2.8-.8,5.92-3.79,9.6-4.08,2.34-.19,6.77-.84,8.28-2.62.56-.79-.19-3.29-.8-5.45-.67-2.36-1.3-6-2.08-5.83a1.06,1.06,0,0,1-.41.88c-.29.3-.68.49-1,.76a6.15,6.15,0,0,0-1.3,1.87,1.41,1.41,0,0,1-.66.72c-.4.14-.69-.1-1-.26a2,2,0,0,0-1.4-.1,9.42,9.42,0,0,1,.25-1.39.74.74,0,0,0,0-.44.66.66,0,0,0-.3-.34A7.43,7.43,0,0,0,359,349.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.9,354.94a2.16,2.16,0,0,1,1.73-1.16c1.06-.2,2.94.59,4.11,1.55a.87.87,0,0,1-.12,1.44h0a.86.86,0,0,1-1-.11A6.7,6.7,0,0,0,352.9,354.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.59,356.79a2.51,2.51,0,0,1,2.05-1.06,7.78,7.78,0,0,1,4.51,1.69.85.85,0,0,1-.12,1.39h0a.83.83,0,0,1-1-.11A6.7,6.7,0,0,0,349.59,356.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,358.45a2.78,2.78,0,0,1,2.12-.95,7.53,7.53,0,0,1,4.32,1.7.86.86,0,0,1-.12,1.4h0a.83.83,0,0,1-1-.11A6.39,6.39,0,0,0,346,358.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.79,238.37c.61,18.47.65,58.47.65,58.47.19,2.3.39,6.38.56,14.66.25,12,.83,41.63.83,41.63s-5.73,2.69-11,.5c0,0-7.32-41.66-8.82-53.54-1.31-10.37-3.82-34.69-3.82-34.69l-3.46,30.87s0,8-.47,15.06c-.39,5.5-5.73,33.83-5.73,33.83a18.36,18.36,0,0,1-10.59-.35s-.48-43.49-.58-48.54c-.11-5.74,1.37-67.8,1.37-67.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.21,265.4l-1.32-10.47a36.59,36.59,0,0,1-11.9-5.46s2.54,3.4,10,7l1.68,9.5-1.9,30.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,186.54c-2.7,3.54-16.59,22.6-16.59,22.6l-12.83-9.94c-3-2.35-3.89-5.43-5.77-7.56s-3.94-2.64-6.05-4.42-2.92-3.13-3.64-1.61,1.61,4.17,2,4.81,2.8,2.17-.38,2-9.3-3.8-10.78-4.47-1.52,1.16-.82,2.36.35,4.54,1.17,6.69,2.26,3.47,5.19,4.92c2.73,1.36,9.37,2.21,11.53,3.57h0c4.74,4.86,13.68,13.93,15.94,15.61,3.11,2.31,6.12,4.44,10.88-.14s18.55-22.55,18.55-22.55l2.85-17.09C364.83,181.15,361.52,182.27,358.26,186.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.67,209.14c1.76,1.3,3.59,4.22,3.76,5.53a9,9,0,0,0-3-6.56Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.61,180.9s-6.6-.08-9.5,1.95-5.05,5-9.76,11.85c-4.13,6-6.13,8.88-6.13,8.88a22.14,22.14,0,0,0,11.21,8.56l12.32-15.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.38,180.58c3.74.36,9,.4,12.7.78,2.57,1.06,7.53,5.38,7.16,8.46-1.38,11.51-4.17,30.38-4.17,30.38l.92,20c-5.15,5.14-29.25,7.15-41.67-1.07,0,0,.4-35.92,1.26-42,1.53-10.89,2.87-14.93,8.49-15.89S383.38,180.58,383.38,180.58Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.56,186.83c2.7,3.54,16.6,22.6,16.6,22.6L434,199.49c3-2.36,3.89-5.44,5.77-7.56s3.94-2.64,6.05-4.42,2.92-3.13,3.64-1.62-1.61,4.18-2,4.82-2.8,2.17.38,2,9.29-3.81,10.78-4.48,1.51,1.16.82,2.36-.36,4.55-1.17,6.7-2.26,3.46-5.19,4.92c-2.73,1.36-9.37,2.21-11.53,3.57h0c-4.74,4.85-13.68,13.93-15.94,15.6-3.11,2.31-6.12,4.44-10.88-.13s-15.64-18.8-15.64-18.8l-5.76-20.84C398,181.44,401.31,182.56,404.56,186.83Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.16,209.43c-1.76,1.3-3.59,4.22-3.76,5.53a9,9,0,0,1,3-6.57Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.67,181.11s5.93-.37,9.05,2c2.81,2.16,5,5,9.76,11.85,4.13,6,6.13,8.88,6.13,8.88a22.2,22.2,0,0,1-11.22,8.56L398,202.06C393.63,196.52,389.3,188.09,392.67,181.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.31,153.5a11.6,11.6,0,1,1-11.7-11.5A11.6,11.6,0,0,1,384.31,153.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.84,161.68s-1.81,8.85-2.55,10.3a4,4,0,0,1-2.29,1.89l.07-6.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.37,149.05a4.33,4.33,0,0,1,3.61,1.23c1.56,1.57.74,6.53-1.14,11.4l-3.54.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.24,162.13c.71.42,1.71-1,2.58-1.88s3.71-2.2,5.17.79-1.2,7.12-3.44,7.84c-3.87,1.26-4.48-1.23-4.48-1.23l-.16,14.42h0c-4.76,6.23-18.15,5.82-12.63-.68l0-4.26a24.52,24.52,0,0,1-5.22.31c-2.86-.41-4.67-2.65-5.57-5.73-1.43-4.94-2-8.94-.9-18.71,1.2-10.7,13.63-10.92,20.38-6.75S388.24,162.13,388.24,162.13Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.25,163.32c.35,0,1.69-2.26,2.57-3.07,1.21-1.13-.45-11.2-.45-11.2a4.9,4.9,0,0,0-.9-5.45c-1.69-1.83-4.05-4.06-11.65-3.1-5.43.69-11.32,2.44-16.11.14a8.13,8.13,0,0,0,2.9,8.6s1.74,1.1,6.29,1.61a67.39,67.39,0,0,0,12.58-.35c1.32-.19,1.61,1.08,2.35,4.57C386.48,158.12,387.05,163.31,388.25,163.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.37,149.83l4.27-2.34a2.36,2.36,0,0,0-3.26-1.05A2.56,2.56,0,0,0,390.37,149.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.25,177.13s6.36-1.34,8.57-2.54a7.32,7.32,0,0,0,3.05-3.07,10,10,0,0,1-1.71,3.6c-1.61,2.1-9.89,3.7-9.89,3.7Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.74,161.11a1.29,1.29,0,0,0,1.28,1.31,1.33,1.33,0,1,0-1.28-1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.53,156.72l-2.84-1.29a1.64,1.64,0,0,0,.8,2.12A1.53,1.53,0,0,0,378.53,156.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.38,155.15l-2.47,1.94a1.49,1.49,0,0,0,2.16.31A1.66,1.66,0,0,0,366.38,155.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89,160.8a1.22,1.22,0,1,0,1.21-1.28A1.24,1.24,0,0,0,364.89,160.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.51 159.77 370.79 167.42 366.84 165.9 371.51 159.77",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.68,170.29a1.23,1.23,0,1,0,1.23-1.22A1.23,1.23,0,0,0,373.68,170.29Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.9,88.82a20.89,20.89,0,0,1,5.46,2.05,15.67,15.67,0,0,1,4.34,3.45A12.37,12.37,0,0,1,417.26,99a11,11,0,0,1,.12,5.62,11.35,11.35,0,0,1-1.72,4.11,13.43,13.43,0,0,1-2.69,2.83,21.92,21.92,0,0,1-3.21,2.07l-3.18,1.68a17.43,17.43,0,0,0-2.72,1.76,5.15,5.15,0,0,0-1.7,2.27,2.37,2.37,0,0,1-.81,1,1.43,1.43,0,0,1-1.22.25l-4.68-1a1.73,1.73,0,0,1-1.1-.76,1.42,1.42,0,0,1-.2-1.27,11.15,11.15,0,0,1,2-4,15.74,15.74,0,0,1,2.88-2.78,22.54,22.54,0,0,1,3.29-2c1.14-.57,2.2-1.12,3.18-1.66a13.89,13.89,0,0,0,2.51-1.7,4,4,0,0,0,1.33-2.2,4.77,4.77,0,0,0-1.12-4.28,8.58,8.58,0,0,0-4.91-2.67q-5.24-1.17-8.86,3.53a3.23,3.23,0,0,1-.87.87,1.57,1.57,0,0,1-1.21.09l-5-1.11a1.35,1.35,0,0,1-.87-.58,1.27,1.27,0,0,1-.19-1.07,9.78,9.78,0,0,1,2.3-4.11,15.48,15.48,0,0,1,4.29-3.32,18.43,18.43,0,0,1,5.65-1.88A16.42,16.42,0,0,1,404.9,88.82Zm-5.28,35.54a1.63,1.63,0,0,1,1.06.76,1.65,1.65,0,0,1,.23,1.28l-1.2,5.42a1.71,1.71,0,0,1-2,1.29l-5.3-1.17a1.65,1.65,0,0,1-1.06-.75,1.62,1.62,0,0,1-.23-1.28l1.2-5.43a1.71,1.71,0,0,1,2-1.29Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.62,139.81a14,14,0,0,1,4-.08,10.81,10.81,0,0,1,3.67,1.1,8.54,8.54,0,0,1,2.82,2.32,7.5,7.5,0,0,1,1.51,3.57,7.65,7.65,0,0,1,0,3.07,9.21,9.21,0,0,1-1,2.51,15.59,15.59,0,0,1-1.52,2.14l-1.61,1.9a13.05,13.05,0,0,0-1.3,1.82,3.58,3.58,0,0,0-.5,1.89,1.65,1.65,0,0,1-.26.88,1,1,0,0,1-.71.47l-3.27.54a1.23,1.23,0,0,1-.9-.21,1,1,0,0,1-.45-.76,7.44,7.44,0,0,1,.23-3.06,10.16,10.16,0,0,1,1.13-2.53,15.53,15.53,0,0,1,1.59-2.13c.59-.66,1.12-1.28,1.62-1.88a9.77,9.77,0,0,0,1.17-1.73,2.76,2.76,0,0,0,.29-1.75,3.29,3.29,0,0,0-1.82-2.46,5.86,5.86,0,0,0-3.82-.46,5.73,5.73,0,0,0-4.78,4.53,2.34,2.34,0,0,1-.34.79,1.11,1.11,0,0,1-.75.36l-3.48.57a1,1,0,0,1-.71-.15.89.89,0,0,1-.4-.64,6.75,6.75,0,0,1,.43-3.22,10.48,10.48,0,0,1,1.9-3.23,12.79,12.79,0,0,1,3.14-2.65A11.38,11.38,0,0,1,420.62,139.81ZM426.33,164a1.16,1.16,0,0,1,.88.21,1.15,1.15,0,0,1,.47.76l.62,3.78a1.16,1.16,0,0,1-.21.88,1.12,1.12,0,0,1-.76.47l-3.7.61a1.15,1.15,0,0,1-.87-.21,1.12,1.12,0,0,1-.48-.76l-.62-3.79a1.19,1.19,0,0,1,1-1.35Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M420.62,139.81a14,14,0,0,1,4-.08,10.81,10.81,0,0,1,3.67,1.1,8.54,8.54,0,0,1,2.82,2.32,7.5,7.5,0,0,1,1.51,3.57,7.65,7.65,0,0,1,0,3.07,9.21,9.21,0,0,1-1,2.51,15.59,15.59,0,0,1-1.52,2.14l-1.61,1.9a13.05,13.05,0,0,0-1.3,1.82,3.58,3.58,0,0,0-.5,1.89,1.65,1.65,0,0,1-.26.88,1,1,0,0,1-.71.47l-3.27.54a1.23,1.23,0,0,1-.9-.21,1,1,0,0,1-.45-.76,7.44,7.44,0,0,1,.23-3.06,10.16,10.16,0,0,1,1.13-2.53,15.53,15.53,0,0,1,1.59-2.13c.59-.66,1.12-1.28,1.62-1.88a9.77,9.77,0,0,0,1.17-1.73,2.76,2.76,0,0,0,.29-1.75,3.29,3.29,0,0,0-1.82-2.46,5.86,5.86,0,0,0-3.82-.46,5.73,5.73,0,0,0-4.78,4.53,2.34,2.34,0,0,1-.34.79,1.11,1.11,0,0,1-.75.36l-3.48.57a1,1,0,0,1-.71-.15.89.89,0,0,1-.4-.64,6.75,6.75,0,0,1,.43-3.22,10.48,10.48,0,0,1,1.9-3.23,12.79,12.79,0,0,1,3.14-2.65A11.38,11.38,0,0,1,420.62,139.81ZM426.33,164a1.16,1.16,0,0,1,.88.21,1.15,1.15,0,0,1,.47.76l.62,3.78a1.16,1.16,0,0,1-.21.88,1.12,1.12,0,0,1-.76.47l-3.7.61a1.15,1.15,0,0,1-.87-.21,1.12,1.12,0,0,1-.48-.76l-.62-3.79a1.19,1.19,0,0,1,1-1.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M454.72,150.54a1.41,1.41,0,0,1,.33,1.94l-2.64,3.7a1.41,1.41,0,0,1-1.94.33l-3.62-2.57a1.35,1.35,0,0,1-.56-.9,1.4,1.4,0,0,1,.23-1l2.64-3.71a1.39,1.39,0,0,1,.9-.56,1.37,1.37,0,0,1,1,.24ZM470,125.45a16.58,16.58,0,0,1,3.46,3.28,12.85,12.85,0,0,1,2.17,4,10.15,10.15,0,0,1,.45,4.31,9,9,0,0,1-1.7,4.27,9.33,9.33,0,0,1-2.6,2.55,10.87,10.87,0,0,1-2.94,1.27,18,18,0,0,1-3.07.54l-2.94.25a15.81,15.81,0,0,0-2.6.46,4.28,4.28,0,0,0-2,1.18,2.11,2.11,0,0,1-.94.53,1.2,1.2,0,0,1-1-.21l-3.2-2.27a1.45,1.45,0,0,1-.58-.92,1.16,1.16,0,0,1,.25-1,9,9,0,0,1,2.75-2.39,12.32,12.32,0,0,1,3.06-1.18,18.7,18.7,0,0,1,3.12-.48c1-.06,2-.14,2.92-.23a11,11,0,0,0,2.43-.49,3.23,3.23,0,0,0,1.7-1.23,3.87,3.87,0,0,0,.52-3.58,7,7,0,0,0-2.84-3.57q-3.57-2.55-7.8-.17a2.8,2.8,0,0,1-.93.38,1.3,1.3,0,0,1-.95-.32l-3.4-2.42a1.15,1.15,0,0,1-.48-.72,1.06,1.06,0,0,1,.21-.86,7.93,7.93,0,0,1,3-2.37,12.69,12.69,0,0,1,4.29-1.13,15.31,15.31,0,0,1,4.85.38A13.32,13.32,0,0,1,470,125.45Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.72,150.54a1.41,1.41,0,0,1,.33,1.94l-2.64,3.7a1.41,1.41,0,0,1-1.94.33l-3.62-2.57a1.35,1.35,0,0,1-.56-.9,1.4,1.4,0,0,1,.23-1l2.64-3.71a1.39,1.39,0,0,1,.9-.56,1.37,1.37,0,0,1,1,.24ZM470,125.45a16.58,16.58,0,0,1,3.46,3.28,12.85,12.85,0,0,1,2.17,4,10.15,10.15,0,0,1,.45,4.31,9,9,0,0,1-1.7,4.27,9.33,9.33,0,0,1-2.6,2.55,10.87,10.87,0,0,1-2.94,1.27,18,18,0,0,1-3.07.54l-2.94.25a15.81,15.81,0,0,0-2.6.46,4.28,4.28,0,0,0-2,1.18,2.11,2.11,0,0,1-.94.53,1.2,1.2,0,0,1-1-.21l-3.2-2.27a1.45,1.45,0,0,1-.58-.92,1.16,1.16,0,0,1,.25-1,9,9,0,0,1,2.75-2.39,12.32,12.32,0,0,1,3.06-1.18,18.7,18.7,0,0,1,3.12-.48c1-.06,2-.14,2.92-.23a11,11,0,0,0,2.43-.49,3.23,3.23,0,0,0,1.7-1.23,3.87,3.87,0,0,0,.52-3.58,7,7,0,0,0-2.84-3.57q-3.57-2.55-7.8-.17a2.8,2.8,0,0,1-.93.38,1.3,1.3,0,0,1-.95-.32l-3.4-2.42a1.15,1.15,0,0,1-.48-.72,1.06,1.06,0,0,1,.21-.86,7.93,7.93,0,0,1,3-2.37,12.69,12.69,0,0,1,4.29-1.13,15.31,15.31,0,0,1,4.85.38A13.32,13.32,0,0,1,470,125.45Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.48,348.52c-.1-3,2.06-32.32,2.06-32.32l-14.28,10.36c2.93,17.48,3.56,21.61,3.61,24.47h0a2.65,2.65,0,0,0-.08.73c0,3.4,3.85,5.23,6.84,7.5a56.63,56.63,0,0,0,8.09,5.28c2.17,1.09,6.59,1.19,7.13-.21-3.64-2.78-8.93-6.94-11.83-10.11C132.64,352.7,132.59,351.5,132.48,348.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.06,368a2.66,2.66,0,0,1-.61,2.73,12.24,12.24,0,0,1-9.08,2.16c-4.54-.59-7-1.88-8.81-3.4s-4.36-3.66-6.42-4.11a12.38,12.38,0,0,1-4.58-1.88c-.61-.59-.53-3.21-.53-3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,350.2a.72.72,0,0,0-.69.61c-.14.72-.29,2.82-.59,4a21.35,21.35,0,0,0-.44,6.36c.25,1.35,3.35,2.28,5.34,3a25.15,25.15,0,0,1,6.44,4.06,18.16,18.16,0,0,0,9.57,3.57c3.5,0,7.44-1.16,8.35-2.78,1.11-2,.24-3.17-4.95-5.58-1-.45-4.43-2.5-5.61-3.24-3.18-2-6.33-4.79-7.8-8.33a2,2,0,0,0-.74-1.08,1.66,1.66,0,0,0-1-.1,8.72,8.72,0,0,0-2.5.76c-.69.33-1.68.72-1.67,1.61a3.09,3.09,0,0,0,.2.9c.06.19.11.43,0,.54s-.35,0-.49-.14a13.19,13.19,0,0,1-1.39-1.68,5.43,5.43,0,0,0-.83-.83,7.88,7.88,0,0,1-.88-.58C123.78,351,123.86,350.62,123.84,350.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.9,368.28c-.91-.74-1.87-1.47-2.83-2.11h0s6.1,3.71,8.56,2a2.2,2.2,0,0,0,.8-2.82c0-.42,3.88-2.23,5.42-2.41h0c.43.24.79.43,1,.53,5.19,2.41,6.06,3.57,4.95,5.58-.91,1.62-3.76,2.89-8.28,2.89C140.58,372,136,370,133.9,368.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,364.14c3.23,1.29,1.85,1.89.95,2s-6.33-3-9.65-5.66-5.63-5.73-6.91-6.73c-.48-.37-1-.83-1.46-1.26.09-.71.16-1.36.22-1.7a.72.72,0,0,1,.69-.61c0,.42-.06.81.26,1.12a7.88,7.88,0,0,0,.88.58,5.43,5.43,0,0,1,.83.83,13.19,13.19,0,0,0,1.39,1.68A42,42,0,0,0,140,364.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,365.69a.32.32,0,0,1-.2-.08.31.31,0,0,1-.05-.44,7.67,7.67,0,0,1,5.91-2.34.33.33,0,0,1,.29.36.32.32,0,0,1-.35.28,7.12,7.12,0,0,0-5.35,2.1A.33.33,0,0,1,140.72,365.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.91,364a.31.31,0,0,1-.21-.07.33.33,0,0,1,0-.45,7.69,7.69,0,0,1,5.91-2.33.32.32,0,0,1-.07.64,7.08,7.08,0,0,0-5.35,2.1A.32.32,0,0,1,137.91,364Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.09,362.31a.31.31,0,0,1-.2-.07.32.32,0,0,1,0-.45,7.7,7.7,0,0,1,5.91-2.33.32.32,0,0,1,.29.35.32.32,0,0,1-.35.29,7.08,7.08,0,0,0-5.35,2.1A.34.34,0,0,1,135.09,362.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.48,360.44a.31.31,0,0,1-.2-.07.31.31,0,0,1,0-.45,7.67,7.67,0,0,1,5.91-2.33.32.32,0,0,1,.28.35.32.32,0,0,1-.35.28,7.15,7.15,0,0,0-5.35,2.1A.32.32,0,0,1,132.48,360.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.93,358.57a.37.37,0,0,1-.2-.07.32.32,0,0,1,0-.45,7.82,7.82,0,0,1,6.45-2.36.3.3,0,0,1,.28.35.32.32,0,0,1-.35.28,7.27,7.27,0,0,0-5.88,2.12A.34.34,0,0,1,129.93,358.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58,329.55l-14.41-.26c.21,9.62,1.74,20.29,2,29.31,0,1.7,0,13.2.6,16.7,1,5.25,7.2,4.54,7.53,1.4s-.4-16.57-.38-18c-.06-5.78,2.65-15.55,4.08-25.94C105.06,332.29,105.51,330.05,105.58,329.55Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.64,378.88a14.39,14.39,0,0,1-1,7.08,4.54,4.54,0,0,1-5,2.36c-2.13-.31-4.94-1.45-5.8-4A16.92,16.92,0,0,1,91,377Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.13,357.5c-.85.15-.69,4.3-.77,8.47-.09,4.48-1.22,6.44-1.33,10.11-.13,4.2.28,6,2,8.38s7.09,4.3,9.26.46c1.77-3.13,1.53-6.38.92-10.5s-1.09-7.24-1.25-10.5-.23-6.15-1-6.42c0,.46,0,1.05,0,1.5s.07,2-.41,2.1a7.48,7.48,0,0,1-.13-1.17,1.42,1.42,0,0,0-.33-1,1.64,1.64,0,0,0-1-.32,22.3,22.3,0,0,0-2.58-.14c-.43,0-.87,0-1.29.07a3.24,3.24,0,0,0-1.07.27.78.78,0,0,0-.43.46,1.29,1.29,0,0,0,0,.48,3.53,3.53,0,0,1,0,.86c0,.13-.09.29-.22.27s-.15-.14-.16-.24c-.06-.5,0-.87-.06-1.45,0-.27,0-.64,0-.91S93.14,357.77,93.13,357.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,374.88c0,.61-.13,4.62,1,5.22s1.57-2.52,1.57-2.52,2.65-1.11,6.81.23c-.14.66.68,2.72,1.73,2.16s1-5.13,1-5.19c.57,4,.75,7.1-1,10.14-2.17,3.84-7.56,1.9-9.26-.46s-2.11-4.18-2-8.38C91,375.66,91.07,375.27,91.1,374.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,377.81c.13,1.5-1.39,1.15-1.67-1s.38-7.24,0-10.88c.08-4.17-.08-8.32.77-8.47a.76.76,0,0,0,0,.15l.1,2.11a6.85,6.85,0,0,0,0,.9c.28,3.06.45,9,.46,11.82A50.39,50.39,0,0,0,94,377.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,377.81a47.78,47.78,0,0,0,.29-5.33c0-2.8.18-8.67.46-11.75a7.7,7.7,0,0,0,.13-1.73c0-.42,0-1,0-1.4,0,0,0-.06,0-.1.56.21.76,1.86.88,3.94,0,1.21,0,2.71-.11,4.53-.38,3.64.28,8.8,0,10.91S99.9,379.31,100,377.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,377.92l-.11,0a10.22,10.22,0,0,0-6.67,0,.32.32,0,1,1-.23-.6,10.6,10.6,0,0,1,7.13,0,.31.31,0,0,1,.18.41A.31.31,0,0,1,100.59,377.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,374.6a.23.23,0,0,1-.11,0,12.58,12.58,0,0,0-7.46,0,.32.32,0,0,1-.41-.2.31.31,0,0,1,.2-.4,13,13,0,0,1,7.89,0,.32.32,0,0,1-.11.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,371.46a.33.33,0,0,1-.29-.19.32.32,0,0,1,.16-.42,10.93,10.93,0,0,1,7.87-.05.31.31,0,0,1,.18.41.32.32,0,0,1-.41.18s-3.92-1.54-7.37,0A.35.35,0,0,1,93.3,371.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.23,368.52a.32.32,0,0,1-.29-.18.32.32,0,0,1,.15-.42,9.89,9.89,0,0,1,8-.09.31.31,0,0,1,.15.42.31.31,0,0,1-.42.15,9.5,9.5,0,0,0-7.48.09A.35.35,0,0,1,93.23,368.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.16,365.23a.32.32,0,0,1-.14-.61c3.81-1.88,7.92-.08,8.09,0a.3.3,0,0,1,.16.42.32.32,0,0,1-.42.16s-4-1.75-7.54,0A.28.28,0,0,1,93.16,365.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.91,236c-5.08,14.07-4.19,22.9-3.32,37.65.8,13.52,2.07,25.43,2.07,25.43-.2,2.4-3.54,7.08-4,17.68a173.65,173.65,0,0,0,1,22.35s6.65,2.43,12.27,0c0,0,5.75-25.39,7.32-37.8,1.36-10.83,3.74-24.67,3.74-24.67l5,24.62a36.38,36.38,0,0,0-1.49,10.19c0,5.79,2.69,21.89,2.69,21.89s7.45,2.41,12.17-1.78c0,0,1.87-23.17,2.53-32,.88-11.78-.4-44.07-3.23-60.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,276.6l2.08-18.52s9.31-1.24,13.53-5.21a15.27,15.27,0,0,1-11,6.93l-3,17.24,3.4,24.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.07,222.27c-4.53-4.66-12.71-15.2-12.71-15.2l-4.62-16a29.88,29.88,0,0,0,3.1,0c5,.33,6.47.76,9.58,4.16,2.47,2.71,11.89,15.57,15.16,19.9l8.69-11.07c2.09-3.15,1.75-6.68,2.83-9.25s2.83-3.7,4.23-6,1.73-3.84,2.88-2.65-.18,4.39-.35,5.12-1.93,2.9,1,1.77,7.45-6.48,8.61-7.57,1.78.6,1.52,1.94,1,4.36.54,6.57a9,9,0,0,1-3.1,5.71c-2.11,2.12-7.27,4.73-9.29,7.52s-6.33,11.46-9,16.68c-3.35,6.64-6.2,8.83-10,6.59S139.74,224,138.07,222.27Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,190.9a16.58,16.58,0,0,1,7.54,1c2.71,1.22,4.55,3.84,7.2,7.39s7.38,9.76,7.38,9.76-1.28,5.39-9.72,10.23l-13.78-14.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58,215.12a10.56,10.56,0,0,0-3.15,5.83s-1-3.21,2.41-6.82Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19,219.31c6.15-5.06,4.12-11.65,1.88-16.09-4.49-8.87-9.16-12.36-11.11-12.33l-12.23.12c-5.84.8-10.36.4-11.77.73-3.6.85-3.68,3.81-3.82,7.64-.15,4.2-2.3,3.49-1.21,10.43a71.63,71.63,0,0,1,3.38,7.95c.66,2.4,2.52,6.22,1.53,10.1-.38,1.5-1.4,3-2.93,7.11a77.43,77.43,0,0,0-3.85,14.26s3.57-.83,7.63-5.15c0,0,5.55,7.43,18.9,6.68,13.85-.78,15.07-8,15.07-8l-2.12-13C131.86,224.51,132,222.61,132.19,219.31Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,218s-5,4-10.87,2.08a10,10,0,0,1-6.79-7s-.5,6.65,6.88,8.79A9.6,9.6,0,0,0,124.2,218Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.19,185.18c-1.81-1.32-11.56,11.73-7,15s9.42-6,8.44-10.38S89.19,185.18,89.19,185.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.34,178.7c2.44-3.38,4.1-5.93,6.33-8.83,1.26-1.65,2.07-2.82,3.28-4.51.84-1.16,1.33-2.14,2.27-2.51a8,8,0,0,0,2.75-2,16.29,16.29,0,0,0,1.29-1.71,25,25,0,0,1,5-5.16c2-1.55,4.19-2.75,6.23-4.23,1.21-.88,2.51-2.33,1-3.64a3.59,3.59,0,0,0-1.62-.74c-3.64-.73-6.79.58-10.33,1.55a30.89,30.89,0,0,0-4.5,1.61,7.73,7.73,0,0,0-2,1.19,10.33,10.33,0,0,0-2,3c-1.55,2.85-4.82,5.39-7.11,7.62-2.69,2.62-5.09,5-8.16,7.91-2.76,2.6-5.47,5-8,7.84-2.09,2.34-1.28,4.14-1,4.75,1.8,3.54,3.76,4.79,6.12,7,.78.72,1.57,1.43,2.36,2.14,3.06,2.76,6.12,5.34,9.3,8,3.4,2.8,4.8,4.16,7.83,6.88a22.49,22.49,0,0,1,4.71,6.13c5.25.87,10.41-7.16,5.91-16.55a9.82,9.82,0,0,0-3.25-3.78C91.21,186.71,80.34,178.7,80.34,178.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.34,178.7A13.82,13.82,0,0,1,74,183.21s3.35.8,7.85-3.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.38,191.66c-1.23-.85-4.22-2.66-10.19-6.48,0,0,.92,1.93-.53,6.78s-4.51,7.92-6.43,8.27c0,0,3.34,2.64,6.42,5.62s5.61,5.09,7.39,8.55c0,0,4.4-1.13,5.4-8.59C102.14,200.58,101.72,194.44,99.38,191.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.78,167.64a12,12,0,0,0-.81-11.71c-3.79-5.39-10.18-8-17.24-7.92l-2.19,0c-9.53.16-18.19,8.34-18.36,17.55h0c0,6.48,0,12.47,3.57,16.89,3.29,4.11,8.42,5.46,12.75,6.12,8.28,1.26,17.58.3,21.34-5.34,0,0-5,1-4.37-4.18.09-.82-.69-1.72-2.06-2.65a27.77,27.77,0,0,1,3.37-4.65C130.19,170.34,131.82,169.55,132.78,167.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.31,172.37c-.05,9.65-3.14,12.08-4.69,12.8s-4.59.34-7.54-.09l.1,5.79s3.45,3.49,3.25,6.15-5.28,3-9.13.51a28.56,28.56,0,0,1-5.72-5,2.1,2.1,0,0,1-.51-1.33l-.24-13.61s-1.58,1.73-4.46-.17a5.26,5.26,0,0,1-1.49-7.61,3.88,3.88,0,0,1,5.92.61c.88,1.64.8,2.8,2,2.61s1.25-1.49,1.33-2.42,0-1.23.12-2.45c2.85-.61,5.8-4.58,6.13-7.48a13.65,13.65,0,0,0,6.21,1.4c3.19-.22,4.84-.86,6.41-3.16a7,7,0,0,1,.89,1.71,22.24,22.24,0,0,1,1,3.79A48.82,48.82,0,0,1,130.31,172.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,185.08c-3.11-.36-9.52-2.08-10.56-4.58a6.54,6.54,0,0,0,2.29,3.18c1.94,1.6,8.3,3.33,8.3,3.33Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21,179.88a1.27,1.27,0,1,1-1.29-1.24A1.27,1.27,0,0,1,121.21,179.88Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,170.38a1.35,1.35,0,0,1-1.23,1.47,1.38,1.38,0,1,1,1.23-1.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6,169.81a1.24,1.24,0,0,1-1.13,1.33,1.15,1.15,0,0,1-1.29-1.17,1.22,1.22,0,0,1,1.12-1.34A1.25,1.25,0,0,1,128.6,169.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.37 168.56 123.33 176.62 127.46 174.9 122.37 168.56",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.76,166.9l2.4-2.28a1.74,1.74,0,0,1-.07,2.4A1.61,1.61,0,0,1,114.76,166.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77,163.88l2.66,2a1.6,1.6,0,0,1-2.3.37A1.76,1.76,0,0,1,126.77,163.88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.43,90.63a20.33,20.33,0,0,1,5.82-.26,15.58,15.58,0,0,1,5.35,1.46,12.31,12.31,0,0,1,4.18,3.26,11,11,0,0,1,2.32,5.11,11.17,11.17,0,0,1,0,4.46,13.16,13.16,0,0,1-1.36,3.66,21.32,21.32,0,0,1-2.13,3.16c-.8,1-1.56,1.92-2.27,2.81a18,18,0,0,0-1.8,2.68,5.17,5.17,0,0,0-.67,2.76,2.52,2.52,0,0,1-.33,1.28,1.45,1.45,0,0,1-1,.71l-4.71.89a1.7,1.7,0,0,1-1.3-.27,1.38,1.38,0,0,1-.69-1.09,11,11,0,0,1,.22-4.44,15.55,15.55,0,0,1,1.55-3.69A22,22,0,0,1,93.84,110c.83-1,1.58-1.9,2.27-2.78a14.49,14.49,0,0,0,1.64-2.55,4,4,0,0,0,.35-2.54,4.74,4.74,0,0,0-2.71-3.5,8.58,8.58,0,0,0-5.56-.53q-5.26,1-6.75,6.74a3.63,3.63,0,0,1-.46,1.14,1.64,1.64,0,0,1-1.09.56l-5,.95a1.43,1.43,0,0,1-1-.19,1.35,1.35,0,0,1-.59-.92,9.8,9.8,0,0,1,.5-4.68A15.46,15.46,0,0,1,78,96.93a18.85,18.85,0,0,1,4.46-4A16.58,16.58,0,0,1,88.43,90.63Zm9.13,34.75a1.74,1.74,0,0,1,2,1.36l1,5.46a1.61,1.61,0,0,1-.27,1.27,1.67,1.67,0,0,1-1.08.72l-5.33,1a1.63,1.63,0,0,1-1.28-.27,1.67,1.67,0,0,1-.72-1.08l-1-5.46a1.65,1.65,0,0,1,.28-1.27,1.6,1.6,0,0,1,1.08-.72Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.25,113.16a13.91,13.91,0,0,1,3.2,2.44,10.49,10.49,0,0,1,2.19,3.14,8.59,8.59,0,0,1,.77,3.57,7.52,7.52,0,0,1-1,3.74,8,8,0,0,1-1.95,2.38,9.33,9.33,0,0,1-2.35,1.33,15,15,0,0,1-2.53.74l-2.44.48a11.59,11.59,0,0,0-2.14.63,3.52,3.52,0,0,0-1.57,1.16,1.7,1.7,0,0,1-.75.53,1,1,0,0,1-.85-.07l-2.89-1.62a1.21,1.21,0,0,1-.58-.72,1,1,0,0,1,.12-.88,7.56,7.56,0,0,1,2.08-2.25,10.7,10.7,0,0,1,2.46-1.28,16,16,0,0,1,2.57-.68c.87-.15,1.68-.3,2.44-.46a10.59,10.59,0,0,0,2-.63,2.84,2.84,0,0,0,1.32-1.19,3.3,3.3,0,0,0,.1-3.06,5.9,5.9,0,0,0-2.71-2.74,5.73,5.73,0,0,0-6.56.58,2.36,2.36,0,0,1-.75.41,1.13,1.13,0,0,1-.82-.18l-3.08-1.72a1,1,0,0,1-.46-.56.92.92,0,0,1,.09-.75,6.83,6.83,0,0,1,2.33-2.26,10.62,10.62,0,0,1,3.5-1.34,12.75,12.75,0,0,1,4.11-.13A11.45,11.45,0,0,1,139.25,113.16Zm-10.54,22.45a1.17,1.17,0,0,1,.56.71,1.14,1.14,0,0,1-.1.89l-1.87,3.35a1.18,1.18,0,0,1-1.6.46l-3.27-1.83a1.07,1.07,0,0,1-.55-.71,1.11,1.11,0,0,1,.09-.89l1.87-3.35a1.16,1.16,0,0,1,.71-.55,1.1,1.1,0,0,1,.89.1Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.25,113.16a13.91,13.91,0,0,1,3.2,2.44,10.49,10.49,0,0,1,2.19,3.14,8.59,8.59,0,0,1,.77,3.57,7.52,7.52,0,0,1-1,3.74,8,8,0,0,1-1.95,2.38,9.33,9.33,0,0,1-2.35,1.33,15,15,0,0,1-2.53.74l-2.44.48a11.59,11.59,0,0,0-2.14.63,3.52,3.52,0,0,0-1.57,1.16,1.7,1.7,0,0,1-.75.53,1,1,0,0,1-.85-.07l-2.89-1.62a1.21,1.21,0,0,1-.58-.72,1,1,0,0,1,.12-.88,7.56,7.56,0,0,1,2.08-2.25,10.7,10.7,0,0,1,2.46-1.28,16,16,0,0,1,2.57-.68c.87-.15,1.68-.3,2.44-.46a10.59,10.59,0,0,0,2-.63,2.84,2.84,0,0,0,1.32-1.19,3.3,3.3,0,0,0,.1-3.06,5.9,5.9,0,0,0-2.71-2.74,5.73,5.73,0,0,0-6.56.58,2.36,2.36,0,0,1-.75.41,1.13,1.13,0,0,1-.82-.18l-3.08-1.72a1,1,0,0,1-.46-.56.92.92,0,0,1,.09-.75,6.83,6.83,0,0,1,2.33-2.26,10.62,10.62,0,0,1,3.5-1.34,12.75,12.75,0,0,1,4.11-.13A11.45,11.45,0,0,1,139.25,113.16Zm-10.54,22.45a1.17,1.17,0,0,1,.56.71,1.14,1.14,0,0,1-.1.89l-1.87,3.35a1.18,1.18,0,0,1-1.6.46l-3.27-1.83a1.07,1.07,0,0,1-.55-.71,1.11,1.11,0,0,1,.09-.89l1.87-3.35a1.16,1.16,0,0,1,.71-.55,1.1,1.1,0,0,1,.89.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.81,149.88a1.36,1.36,0,0,1,1-.37,1.4,1.4,0,0,1,1,.44l3.08,3.34a1.41,1.41,0,0,1-.08,2l-3.26,3a1.41,1.41,0,0,1-2-.08l-3.08-3.34a1.4,1.4,0,0,1,.08-2Zm-21.4-20.15A16.73,16.73,0,0,1,51.33,127a12.87,12.87,0,0,1,4.34-1.3,10.31,10.31,0,0,1,4.31.44,9,9,0,0,1,3.83,2.55,9.22,9.22,0,0,1,2,3.07,10.84,10.84,0,0,1,.64,3.13,18,18,0,0,1-.1,3.12c-.13,1-.25,2-.36,2.93a14.82,14.82,0,0,0-.09,2.64,4.2,4.2,0,0,0,.74,2.21,2,2,0,0,1,.32,1,1.15,1.15,0,0,1-.4.93l-2.88,2.67a1.43,1.43,0,0,1-1,.37,1.14,1.14,0,0,1-.95-.45,9.17,9.17,0,0,1-1.78-3.18,12.58,12.58,0,0,1-.52-3.23,18.33,18.33,0,0,1,.18-3.16c.15-1,.27-2,.37-2.9a11.57,11.57,0,0,0,0-2.49,3.25,3.25,0,0,0-.85-1.91,3.89,3.89,0,0,0-3.4-1.25,7.07,7.07,0,0,0-4.08,2q-3.22,3-1.77,7.61a2.89,2.89,0,0,1,.18,1,1.29,1.29,0,0,1-.51.85l-3.07,2.84a1.14,1.14,0,0,1-.8.32,1.07,1.07,0,0,1-.8-.38A7.9,7.9,0,0,1,43.15,143a12.54,12.54,0,0,1-.23-4.43,15.16,15.16,0,0,1,1.38-4.67A13.42,13.42,0,0,1,47.41,129.73Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.81,149.88a1.36,1.36,0,0,1,1-.37,1.4,1.4,0,0,1,1,.44l3.08,3.34a1.41,1.41,0,0,1-.08,2l-3.26,3a1.41,1.41,0,0,1-2-.08l-3.08-3.34a1.4,1.4,0,0,1,.08-2Zm-21.4-20.15A16.73,16.73,0,0,1,51.33,127a12.87,12.87,0,0,1,4.34-1.3,10.31,10.31,0,0,1,4.31.44,9,9,0,0,1,3.83,2.55,9.22,9.22,0,0,1,2,3.07,10.84,10.84,0,0,1,.64,3.13,18,18,0,0,1-.1,3.12c-.13,1-.25,2-.36,2.93a14.82,14.82,0,0,0-.09,2.64,4.2,4.2,0,0,0,.74,2.21,2,2,0,0,1,.32,1,1.15,1.15,0,0,1-.4.93l-2.88,2.67a1.43,1.43,0,0,1-1,.37,1.14,1.14,0,0,1-.95-.45,9.17,9.17,0,0,1-1.78-3.18,12.58,12.58,0,0,1-.52-3.23,18.33,18.33,0,0,1,.18-3.16c.15-1,.27-2,.37-2.9a11.57,11.57,0,0,0,0-2.49,3.25,3.25,0,0,0-.85-1.91,3.89,3.89,0,0,0-3.4-1.25,7.07,7.07,0,0,0-4.08,2q-3.22,3-1.77,7.61a2.89,2.89,0,0,1,.18,1,1.29,1.29,0,0,1-.51.85l-3.07,2.84a1.14,1.14,0,0,1-.8.32,1.07,1.07,0,0,1-.8-.38A7.9,7.9,0,0,1,43.15,143a12.54,12.54,0,0,1-.23-4.43,15.16,15.16,0,0,1,1.38-4.67A13.42,13.42,0,0,1,47.41,129.73Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-mark--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--big-question-mark--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.44,219.65c-2.85-1.63-14.85-8.57-18.93-10.93-.81-.46-1.32-.76-1.36-.79a9.58,9.58,0,0,0-6.67-1,17.39,17.39,0,0,0-5.52,2.15c-.28.16-.56.35-.83.53-4.61,2.91-8.57,7.49-11.87,13.79a42.75,42.75,0,0,0-5.25,20q0,9.94,5.3,13.95a10.7,10.7,0,0,0,1.12.73c3.31,1.88,19.91,11.5,20.28,11.71l.09,0a9.33,9.33,0,0,1-1.17-.76q-5.31-4-5.3-13.94a42.75,42.75,0,0,1,5.25-20q5.23-10,12.69-14.33,7.1-4.1,12.26-1.07Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,219.71q-5.16-3-12.26,1.06-6.93,4-11.95,13L228,222c3.14-5.61,6.85-9.74,11.12-12.43.27-.17.55-.37.83-.53a17.12,17.12,0,0,1,5.52-2.14,9.52,9.52,0,0,1,6.67,1l1.36.79c4.08,2.35,16.08,9.29,18.93,10.92Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,269.76l-.09,0c-.37-.21-17-9.83-20.28-11.71a10.7,10.7,0,0,1-1.12-.73q-5.3-4-5.3-13.94a42.69,42.69,0,0,1,5.25-20c.24-.47.49-.93.75-1.37l20.31,11.73c-.25.44-.5.9-.74,1.36a42.75,42.75,0,0,0-5.25,20q0,9.94,5.3,13.94A9.33,9.33,0,0,0,248.8,269.76Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.58,48.05q14.79-8.55,25.18-7.27a21,21,0,0,1,8,2.66,2.12,2.12,0,0,1-.2-.12c-2.38-1.34-16.72-9.61-20-11.54a20.91,20.91,0,0,0-8.16-2.72q-10.4-1.27-25.19,7.26-23,13.27-37,39t-13.85,52.53l20.31,11.73q-.21-26.82,13.85-52.54T263.58,48.05Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.6,43.33a21.41,21.41,0,0,0-7.84-2.55q-10.38-1.28-25.18,7.27-23,13.26-37,39c-.39.71-.77,1.43-1.14,2.14L205.08,77.44c.37-.71.75-1.43,1.14-2.14q14.06-25.71,37-39,14.81-8.54,25.19-7.26a20.92,20.92,0,0,1,8.16,2.73C279.88,33.72,294.22,42,296.6,43.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39,89.17q-12.91,24.69-12.71,50.39l-20.31-11.73q-.19-25.71,12.71-50.39Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.38,81.29q-5.53-2.94-14.77,2.3a36.82,36.82,0,0,1-2.24,10.72q-2.31,6.22-13.44,25.66-11.53,20.1-16.68,38.39a136.14,136.14,0,0,0-5.14,37l.1,6.23,13.86,8,6.46,3.73-.11-6.24V207a136.61,136.61,0,0,1,5.14-36.88q5.15-18.29,16.69-38.38,11.12-19.44,13.43-25.67A36.52,36.52,0,0,0,283,93.23Q283,84.28,277.38,81.29Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.69,110.56q-3.44,7.16-11.44,21.14-11.55,20.1-16.69,38.39A136.54,136.54,0,0,0,245.42,207v.16l.11,6.24-6.46-3.72-13.86-8-.1-6.24a136.2,136.2,0,0,1,5.14-37q5.15-18.29,16.68-38.39,8-14,11.46-21.13Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,93.23a36.52,36.52,0,0,1-2.31,12.8c-.43,1.17-1.1,2.68-2,4.53l-20.3-11.72q1.33-2.78,2-4.53a36.82,36.82,0,0,0,2.24-10.72q9.24-5.24,14.77-2.3T283,93.23Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,123.68l-27.49,15.88q-.21-26.82,13.85-52.54t37-39q14.79-8.55,25.18-7.27t16.63,11.39q6.25,10.11,6.25,25.22a81.52,81.52,0,0,1-2,17.38,130.84,130.84,0,0,1-6.29,20q-2.52,6.36-12.07,23.48-9.13,16.32-11.44,22.21A79.47,79.47,0,0,0,276,174.8a150.73,150.73,0,0,0-2,22.14l-28.43,16.42-.11-6.24a136.2,136.2,0,0,1,5.14-37q5.15-18.29,16.69-38.38,11.12-19.44,13.43-25.67A36.52,36.52,0,0,0,283,93.23q0-9-5.61-11.94t-15.06,2.46q-9.66,5.58-15.85,16.74A48,48,0,0,0,240.17,123.68Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.22,220.83q7.65-4.43,13.06-.55t5.41,13.81a42.9,42.9,0,0,1-5.35,20.09Q268,264.33,260.43,268.7t-12.86.36q-5.3-4-5.3-13.95a42.75,42.75,0,0,1,5.25-20Q252.77,225.13,260.22,220.83Z",
    style: {
      fill: "#D175F7"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC14);
export default __webpack_public_path__ + "static/media/c14.3028c5e89f897260b16118e1d54c9d05.svg";
export { ForwardRef as ReactComponent };